function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  rx: 1,
  fill: "#F0F0F5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.99836 4.69644C10.1537 4.69356 11.9515 6.34405 12.1348 8.49332C12.3181 10.6426 10.8256 12.5742 8.70089 12.9369C6.62036 13.292 4.61361 12.0267 4.02516 10.0129C3.97792 9.85119 4.10159 9.69613 4.26393 9.69613H5.10357C5.21057 9.69613 5.3026 9.76378 5.33893 9.85947C5.84287 11.1869 7.25087 11.9438 8.63975 11.6231C10.0506 11.2973 10.9926 9.96337 10.8284 8.52315C10.6643 7.08298 9.4464 5.99574 7.99859 5.99638C7.29447 5.99742 6.61834 6.26323 6.10268 6.73797L7.43219 8.06958C7.58949 8.22713 7.47791 8.49622 7.25528 8.49622H4.1C3.96193 8.49622 3.85 8.38429 3.85 8.24622V5.08795C3.85 4.86519 4.11935 4.75367 4.27682 4.91122L5.1759 5.81078C5.93987 5.09551 6.9485 4.69584 7.99836 4.69644ZM7.99836 4.69644C7.99841 4.69644 7.99846 4.69644 7.99851 4.69644L7.99842 4.84644L7.99821 4.69644C7.99826 4.69644 7.99831 4.69644 7.99836 4.69644Z",
  fill: "#1A172A",
  stroke: "#1A172A",
  strokeWidth: 0.3
});

function SvgLoop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoop);
export default __webpack_public_path__ + "static/media/loop.94be6a98.svg";
export { ForwardRef as ReactComponent };